/** @format */

const NavbarTranslations = {
  en: {
    'Spaces.label': 'ORIENTATION AND MEETING POINTS',
    'Spaces.title': 'Meet us',
    'Spaces.title1': 'in the',
    'Spaces.title2': 'spaces',
    'Spaces.title3': 'WeMi',
    'Spaces.description':
      'The wemi spaces are meeting and orientation points where, thanks to specialized operators, find the welfare solutions most suited to your needs and those of your family, take advantage of WeMi services, activate forms of shared Welfare and develop voluntary actions.',
    'Spaces.description1':
      'The wemi spaces are managed by associations and cooperatives that collaborate with the Municipality of Milan and are located in very different places.',
    'Spaces.description2': 'Find out where they are and click below to get to know them better:',
  },
  it: {
    'Spaces.label': 'PUNTI DI ORIENTAMENTO E INCONTRO',
    'Spaces.title': 'Incontraci',
    'Spaces.title1': 'negli',
    'Spaces.title2': 'spazi',
    'Spaces.title3': 'WeMi',
    'Spaces.description':
      'Gli spazi wemi sono punti di incontro e orientamento nei quali, grazie a operatori specializzati, trovare le soluzioni di welfare più adatte ai tuoi bisogni e a quelli della tua famiglia, fruire dei servizi WeMi, attivare forme di Welfare condiviso e sviluppare azioni di volontariato.',
    'Spaces.description1':
      "Gli spazi wemi sono gestiti da associazioni e cooperative che collaborano con il Comune di Milano e si trovano all'interno di luoghi molto diversi tra loro.",
    'Spaces.description2': 'Scopri dove sono e clicca qui sotto per conoscerli meglio:',
  },
};

export default NavbarTranslations;
